<landing-summary
    [widgetConfig]="config"
    [actionLabel]="'WIDGET.BUDGET_VISION.GO_TO_FUNNEL' | translate"
    (actionClick)="navigateToFunnel()"
/>
